import React from 'react';
import moment from 'moment';
import { getTaskStatus } from 'global/utils';
import { Loader } from 'global/styles';
import { Icon } from '@material-ui/core';
import { get, size } from 'global/lib/lodash';
import { ImageList } from 'global/components/image';
import useStyles from './comment.styles';
import { Text } from '../text';

export default (props) => {
  const { author, body, createdAt, images, meta, isNew } = props;
  const classes = useStyles();

  const status = getTaskStatus(meta);

  const hasImages = size(images) > 0;

  const isCorrection = get(meta, 'showCorrection');
  const showIcon = get(props, 'showIcon', true);

  return (
    <div className={classes.container}>
      {showIcon && <div className={classes.leftIcon}>{isNew ? <Loader size={16} classes={{ svg: classes.whiteIcon }} /> : <Icon>{status.icon}</Icon>}</div>}

      <div className={classes.textContainer}>
        <div className={classes.dateRow}>
          <div className={classes.author}>{get(author, 'name', get(author, 'email', ''))}</div>
          <div className={classes.date}>{moment(createdAt).format('L hh:mma')}</div>
        </div>

        {isCorrection && (
          <div className={classes.correctionContainer}>
            <Text type="secondarySub">Status</Text>
            <span className={classes.bold}>{`Correction: `}</span>
            <span>{`status changed to ${status.title}`}</span>
          </div>
        )}

        <div className={classes.text}>
          <Text type="secondarySub">Comment</Text>
          {body}
        </div>

        {hasImages && (
          <div className={classes.imagesContainer}>
            <ImageList images={images} showCaption={true} spaceBetween={2} />
          </div>
        )}
      </div>
    </div>
  );
};
